 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		2: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","4":"component---src-pages-404-js","5":"component---src-pages-about-js","6":"component---src-pages-api-pipeline-js","7":"component---src-pages-blog-js","8":"component---src-pages-casestudies-js","9":"component---src-pages-composable-js","10":"component---src-pages-contacts-book-demo-js","11":"component---src-pages-contacts-enterprise-js","12":"component---src-pages-contacts-get-pricing-js","13":"component---src-pages-contacts-lets-talk-js","14":"component---src-pages-contacts-marketplaces-js","15":"component---src-pages-contacts-partners-js","16":"component---src-pages-contacts-retailer-model-js","17":"component---src-pages-contacts-sellers-js","18":"component---src-pages-data-processing-agreement-js","19":"component---src-pages-enterprise-contact-js","20":"component---src-pages-enterprise-js","21":"component---src-pages-faqs-js","22":"component---src-pages-faqs-rebranding-js","23":"component---src-pages-features-js","24":"component---src-pages-features-testt-js","25":"component---src-pages-headless-download-js","26":"component---src-pages-index-js","27":"component---src-pages-onboarding-create-product-js","28":"component---src-pages-onboarding-js","29":"component---src-pages-onboarding-order-js","30":"component---src-pages-onboarding-payments-js","31":"component---src-pages-onboarding-returns-js","32":"component---src-pages-onboarding-shipping-js","33":"component---src-pages-onboarding-tax-and-invoicing-js","34":"component---src-pages-onport-logistics-js","35":"component---src-pages-partners-channel-status-js","36":"component---src-pages-partners-js","37":"component---src-pages-partners-shipping-status-js","38":"component---src-pages-partners-vendor-status-js","39":"component---src-pages-privacy-candidate-js","40":"component---src-pages-privacy-js","41":"component---src-pages-privacy-onport-unite-js","42":"component---src-pages-rev-ops-info-price-js","43":"component---src-pages-support-packages-js","44":"component---src-pages-terms-js","45":"component---src-pages-test-sellers-js","46":"component---src-pages-thanks-book-demo-js","47":"component---src-pages-thanks-enterprise-js","48":"component---src-pages-thanks-get-pricing-js","49":"component---src-pages-thanks-js","50":"component---src-pages-thanks-lets-talk-js","51":"component---src-pages-thanks-partners-js","52":"component---src-pages-thanks-retailer-model-js","53":"component---src-pages-thanks-sellers-js","54":"component---src-pages-thanks-use-cases-a-curated-distribution-network-for-your-brand-js","55":"component---src-pages-thanks-use-cases-automate-marketplace-operations-js","56":"component---src-pages-thanks-use-cases-create-a-marketplace-js","57":"component---src-pages-thanks-use-cases-expand-product-offering-js","58":"component---src-pages-thanks-use-cases-expand-your-market-js","59":"component---src-pages-thanksv-2-js","60":"component---src-templates-blog-post-js","61":"component---src-templates-case-study-js","62":"component---src-templates-feature-category-js","63":"component---src-templates-feature-js","64":"component---src-templates-partner-category-js","65":"component---src-templates-partner-js","66":"component---src-templates-use-case-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"3261a25c47150a82910d","4":"aa71797765512ae514d4","5":"c848179b0de01a43fd97","6":"1cb3dead6e0235f215d3","7":"bbb63efb5c75b3b37911","8":"2bfcd2cef61e90d31da6","9":"65ff295321edda4d901c","10":"497ca492e278382f6e39","11":"fc56be82cab7187b7899","12":"ab1730575b7ab8958694","13":"bc21c5afd53cb4bc9408","14":"c0959170eb9d4f1f85f7","15":"e5234bc54480b75d196f","16":"74b904360640d5f70de5","17":"10adecc84f13c10a6d41","18":"57efcf1ac0b11c8a2c75","19":"81e033dd395a2c5694f3","20":"3ada6506c0f410a7bd89","21":"b98cfbd49abd390c5fe5","22":"842f0939b42a1db06e01","23":"c9f484fbd484b9e6c309","24":"6502d4efe19bd09a0012","25":"c22eedd9f6d669ff5727","26":"4f6c01052038ac2124b4","27":"f98e27e7d88d09d59c5c","28":"565158f6ebb9db5d43c4","29":"17b0c379238b0bd56a69","30":"da0c8dab152d31f53265","31":"75a585ed0d94083c6443","32":"908142ef72a924e650ec","33":"b3c92b9833eb577b797d","34":"eddca9402d09b6248740","35":"3b4b0ee38bedabb1e0ed","36":"d0d76580da9c6e130cd8","37":"b81ee66d23028ef72220","38":"eef320a4d16a80fe544c","39":"efcc086171de844eea9e","40":"34ace802dc0b5ee64440","41":"d7295912c9a209c6488a","42":"0d63c66366bb8fc2ecdb","43":"85886ea04e3821512492","44":"71cb28f6dda49a1592ba","45":"829dbb8c1b572ed46382","46":"3f30c893416cffceb0aa","47":"319ba8d61a34b75c2c9e","48":"4a532e4fd3d12ca718d8","49":"78fcd0037e299649c7c5","50":"11416e2658d79a699f41","51":"1286b56238219188e679","52":"8420d547a09b36cb5435","53":"3702ccb85bd3e48cf0a2","54":"f3607961da9c5845d744","55":"539cc6504460332aeb80","56":"2b22b1f925318386a5f5","57":"91d87ab93f0d549470f1","58":"7a872fe591c91ab383b5","59":"41f2dfdca1aa8a6720d2","60":"0a50e32ffb2204a22b26","61":"a5b875f8fe7c22db786f","62":"d342e3bc57b2d97f6f23","63":"3143ed09749811cd315d","64":"3dcfc78a750387e9bb2e","65":"5287f46bd1b12cb9f6d4","66":"ca3d924baca4c9b6e33c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","4":"component---src-pages-404-js","5":"component---src-pages-about-js","6":"component---src-pages-api-pipeline-js","7":"component---src-pages-blog-js","8":"component---src-pages-casestudies-js","9":"component---src-pages-composable-js","10":"component---src-pages-contacts-book-demo-js","11":"component---src-pages-contacts-enterprise-js","12":"component---src-pages-contacts-get-pricing-js","13":"component---src-pages-contacts-lets-talk-js","14":"component---src-pages-contacts-marketplaces-js","15":"component---src-pages-contacts-partners-js","16":"component---src-pages-contacts-retailer-model-js","17":"component---src-pages-contacts-sellers-js","18":"component---src-pages-data-processing-agreement-js","19":"component---src-pages-enterprise-contact-js","20":"component---src-pages-enterprise-js","21":"component---src-pages-faqs-js","22":"component---src-pages-faqs-rebranding-js","23":"component---src-pages-features-js","24":"component---src-pages-features-testt-js","25":"component---src-pages-headless-download-js","26":"component---src-pages-index-js","27":"component---src-pages-onboarding-create-product-js","28":"component---src-pages-onboarding-js","29":"component---src-pages-onboarding-order-js","30":"component---src-pages-onboarding-payments-js","31":"component---src-pages-onboarding-returns-js","32":"component---src-pages-onboarding-shipping-js","33":"component---src-pages-onboarding-tax-and-invoicing-js","34":"component---src-pages-onport-logistics-js","35":"component---src-pages-partners-channel-status-js","36":"component---src-pages-partners-js","37":"component---src-pages-partners-shipping-status-js","38":"component---src-pages-partners-vendor-status-js","39":"component---src-pages-privacy-candidate-js","40":"component---src-pages-privacy-js","41":"component---src-pages-privacy-onport-unite-js","42":"component---src-pages-rev-ops-info-price-js","43":"component---src-pages-support-packages-js","44":"component---src-pages-terms-js","45":"component---src-pages-test-sellers-js","46":"component---src-pages-thanks-book-demo-js","47":"component---src-pages-thanks-enterprise-js","48":"component---src-pages-thanks-get-pricing-js","49":"component---src-pages-thanks-js","50":"component---src-pages-thanks-lets-talk-js","51":"component---src-pages-thanks-partners-js","52":"component---src-pages-thanks-retailer-model-js","53":"component---src-pages-thanks-sellers-js","54":"component---src-pages-thanks-use-cases-a-curated-distribution-network-for-your-brand-js","55":"component---src-pages-thanks-use-cases-automate-marketplace-operations-js","56":"component---src-pages-thanks-use-cases-create-a-marketplace-js","57":"component---src-pages-thanks-use-cases-expand-product-offering-js","58":"component---src-pages-thanks-use-cases-expand-your-market-js","59":"component---src-pages-thanksv-2-js","60":"component---src-templates-blog-post-js","61":"component---src-templates-case-study-js","62":"component---src-templates-feature-category-js","63":"component---src-templates-feature-js","64":"component---src-templates-partner-category-js","65":"component---src-templates-partner-js","66":"component---src-templates-use-case-js"}[chunkId]||chunkId) + "." + {"0":"ff51bb9f8e0048b02706","1":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
